import Icon from "../../ui/Icon";
import Button from "../../ui/Button";
import {useEffect} from "react";
import PageTitle from "../../ui/PageTitle";
import {useLocation, useNavigate} from "react-router-dom";
import MESSAGES from "../../constants/messages";
import {HUB_REGISTER_URL} from "../../Services/hub";

import "./index.scss";

const SuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const {transactionId, value} = location.state || {};
    if (!transactionId || value == null) {
      return;
    }

    // Guard against re-firing the same purchase (page refresh, browser
    // back/forward landing back on this route) so Ads/GTM don't double-count.
    const firedKey = `purchase_reported_${transactionId}`;
    try {
      if (sessionStorage.getItem(firedKey)) {
        return;
      }
      sessionStorage.setItem(firedKey, "1");
    } catch {
      // sessionStorage unavailable (e.g. private browsing) -- fall through
      // and report anyway rather than silently dropping the conversion.
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "purchase",
      value,
      currency: "USD",
      transaction_id: transactionId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid success-page">
      <div className="container">
        <PageTitle title={MESSAGES.THANK_YOU} />
        <div className="content-block">
          <div>
            <Icon type="BsFillCheckCircleFill" />
          </div>
          <div>
            {MESSAGES.THANK_YOU_DESCRIPTION}
          </div>
          <div className="register-cta">
            Want to track this registration&apos;s status and get notified the
            moment it&apos;s updated?{" "}
            <a href={HUB_REGISTER_URL}>Create a free account →</a>
          </div>
        </div>
        <div className="footer-block">
          <Button onClick={() => navigate("/")}>{MESSAGES.RETURN_TO_HOME_PAGE}</Button>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
